import { ReactNode, forwardRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from './Buttons/Button';
import Slide, { SlideProps } from '@mui/material/Slide';

export type ConfirmationDialogProps = {
    open: boolean;
    title?: string;
    okButtonText: string;
    cancelButtonText: string;
    disableOk?: boolean;
    onOk: () => void;
    onCancel: () => void;
    children: ReactNode;
};

const TransitionComponent = forwardRef<unknown, SlideProps>((props, ref) => (
    <Slide ref={ref} direction="up" {...props} />
));

const ConfirmationDialog = ({
    open,
    onCancel,
    onOk,
    title,
    okButtonText,
    cancelButtonText,
    disableOk,
    children,
}: ConfirmationDialogProps) => (
    <Dialog
        TransitionComponent={TransitionComponent}
        open={open}
        onClose={onCancel}
        maxWidth={'xs'}
    >
        {title && <DialogTitle>{title}</DialogTitle>}
        <DialogContent>{children}</DialogContent>
        <DialogActions>
            <Button onClick={onOk} disabled={disableOk}>{okButtonText}</Button>
            <Button onClick={onCancel} className="alt">{cancelButtonText}</Button>
        </DialogActions>
    </Dialog>
);

export default ConfirmationDialog;
